import { useContent } from "../components/ContentProvider";

export default function useResumeContent() {
	return useContent("resume");
}
